module.exports = __webpack_public_path__ + "img/dgroup_22.cb562870.jpg";